import React from 'react';
import PropTypes from 'prop-types';
import classNames from '../utils/classNames';

var getTooltipAngle = function getTooltipAngle(placement) {
  switch (placement) {
    case 'top':
      return -45;

    case 'bottom':
      return 135;

    case 'left':
      return -135;

    case 'right':
      return 45;

    default:
      return 135;
  }
};

var getTooltipPositionClass = function getTooltipPositionClass(placement) {
  var classPrefix = 'psw-l-anchor-';

  switch (placement) {
    case 'top':
      return "".concat(classPrefix, "bottom-center");

    case 'bottom':
      return "".concat(classPrefix, "top-center");

    case 'left':
      return "".concat(classPrefix, "center-right");

    case 'right':
      return "".concat(classPrefix, "center-left");

    default:
      return "".concat(classPrefix, "bottom-center");
  }
};
/**
 * Responsible for rendering the tooltip arrow in the correct orientation
 * @private
 */


var TooltipArrow = function TooltipArrow(_ref) {
  var placement = _ref.placement,
      xDiff = _ref.xDiff,
      yDiff = _ref.yDiff,
      hide = _ref.hide,
      variant = _ref.variant;
  return /*#__PURE__*/React.createElement("div", {
    className: classNames('psw-tooltip-arrow', getTooltipPositionClass(placement))
  }, /*#__PURE__*/React.createElement("div", {
    style: {
      transform: "translate(".concat(xDiff, "px, ").concat(yDiff, "px) rotate(").concat(getTooltipAngle(placement), "deg)"),
      clipPath: 'polygon(-200% -200%, 300% 300%, -200% 300%)'
    },
    className: classNames('psw-s-feature', variant === 'blueBgColor' ? 'psw-bg-blue-tooltip' : 'psw-c-bg-1', 'psw-p-t-5', 'psw-p-l-5', variant === 'blueBgColor' ? '' : 'psw-r-1', hide && 'psw-hidden')
  }));
};

TooltipArrow.defaultProps = {
  placement: null,
  hide: false,
  xDiff: 0,
  yDiff: 0,
  variant: 'default'
};
TooltipArrow.propTypes = {
  hide: PropTypes.bool,
  placement: PropTypes.oneOf(['top', 'bottom', 'left', 'right']),
  xDiff: PropTypes.number,
  yDiff: PropTypes.number,
  variant: PropTypes.oneOf(['default', 'blueBgColor'])
};
export default TooltipArrow;